var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExplorar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.512,
    height: 10.725,
    viewBox: "0 0 12.512 10.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-arrow-right",
    "data-name": "Icon metro-arrow-right",
    d: "M12.281,16.247l4.469-4.469a.894.894,0,0,0,0-1.264L12.281,6.046A.894.894,0,1,0,11.017,7.31l2.943,2.943H5.392a.894.894,0,0,0,0,1.787H13.96l-2.943,2.943a.894.894,0,0,0,1.264,1.264Z",
    transform: "translate(-4.499 -5.784)",
    fill: "#81d742"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExplorar);
export default __webpack_public_path__ + "static/media/Explorar.a7d0728cdbf75a94e26d9c37380589a0.svg";
export { ForwardRef as ReactComponent };